/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF API v2.0
 * TAF API with OpenAPI, Swashbuckle, and API versioning.
 * OpenAPI spec version: 2.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  AvailableBookingPeriod,
  BookingGroup,
  BookingObject,
  GetAvailablePeriodsForMonthByObjectIdRequest,
  GetBookingsByObjectIdRequest,
  IAvailableBookingPeriod,
  IBooking,
  IError
} from '../../models'
import { customInstance } from '../../../../utils/mutator/custom-instance';
import type { ErrorType, BodyType } from '../../../../utils/mutator/custom-instance';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const getApiV2ObjectBookingGroups = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BookingGroup[]>(
      {url: `/proxy/api/v2/object-booking/groups`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV2ObjectBookingGroupsQueryKey = () => {
    return [`/proxy/api/v2/object-booking/groups`] as const;
    }

    
export const getGetApiV2ObjectBookingGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV2ObjectBookingGroups>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingGroups>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV2ObjectBookingGroupsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV2ObjectBookingGroups>>> = ({ signal }) => getApiV2ObjectBookingGroups(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingGroups>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV2ObjectBookingGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV2ObjectBookingGroups>>>
export type GetApiV2ObjectBookingGroupsQueryError = ErrorType<unknown>



export function useGetApiV2ObjectBookingGroups<TData = Awaited<ReturnType<typeof getApiV2ObjectBookingGroups>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingGroups>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV2ObjectBookingGroupsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV2ObjectBookingGroupsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV2ObjectBookingGroups>>, TError = ErrorType<unknown>>( options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingGroups>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV2ObjectBookingGroupsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV2ObjectBookingGroups>>> = ({ signal }) => getApiV2ObjectBookingGroups(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingGroups>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV2ObjectBookingGroupsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV2ObjectBookingGroups>>>
export type GetApiV2ObjectBookingGroupsSuspenseQueryError = ErrorType<unknown>



export function useGetApiV2ObjectBookingGroupsSuspense<TData = Awaited<ReturnType<typeof getApiV2ObjectBookingGroups>>, TError = ErrorType<unknown>>(
  options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingGroups>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV2ObjectBookingGroupsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiV2ObjectBookingGroupsGroupIdObjects = (
    groupId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BookingObject[]>(
      {url: `/proxy/api/v2/object-booking/groups/${groupId}/objects`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV2ObjectBookingGroupsGroupIdObjectsQueryKey = (groupId: string,) => {
    return [`/proxy/api/v2/object-booking/groups/${groupId}/objects`] as const;
    }

    
export const getGetApiV2ObjectBookingGroupsGroupIdObjectsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV2ObjectBookingGroupsGroupIdObjects>>, TError = ErrorType<unknown>>(groupId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingGroupsGroupIdObjects>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV2ObjectBookingGroupsGroupIdObjectsQueryKey(groupId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV2ObjectBookingGroupsGroupIdObjects>>> = ({ signal }) => getApiV2ObjectBookingGroupsGroupIdObjects(groupId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(groupId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingGroupsGroupIdObjects>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV2ObjectBookingGroupsGroupIdObjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV2ObjectBookingGroupsGroupIdObjects>>>
export type GetApiV2ObjectBookingGroupsGroupIdObjectsQueryError = ErrorType<unknown>



export function useGetApiV2ObjectBookingGroupsGroupIdObjects<TData = Awaited<ReturnType<typeof getApiV2ObjectBookingGroupsGroupIdObjects>>, TError = ErrorType<unknown>>(
 groupId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingGroupsGroupIdObjects>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV2ObjectBookingGroupsGroupIdObjectsQueryOptions(groupId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV2ObjectBookingGroupsGroupIdObjectsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV2ObjectBookingGroupsGroupIdObjects>>, TError = ErrorType<unknown>>(groupId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingGroupsGroupIdObjects>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV2ObjectBookingGroupsGroupIdObjectsQueryKey(groupId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV2ObjectBookingGroupsGroupIdObjects>>> = ({ signal }) => getApiV2ObjectBookingGroupsGroupIdObjects(groupId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingGroupsGroupIdObjects>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV2ObjectBookingGroupsGroupIdObjectsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV2ObjectBookingGroupsGroupIdObjects>>>
export type GetApiV2ObjectBookingGroupsGroupIdObjectsSuspenseQueryError = ErrorType<unknown>



export function useGetApiV2ObjectBookingGroupsGroupIdObjectsSuspense<TData = Awaited<ReturnType<typeof getApiV2ObjectBookingGroupsGroupIdObjects>>, TError = ErrorType<unknown>>(
 groupId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingGroupsGroupIdObjects>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV2ObjectBookingGroupsGroupIdObjectsSuspenseQueryOptions(groupId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiV2ObjectBookingObjectsObjectId = (
    objectId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BookingObject>(
      {url: `/proxy/api/v2/object-booking/objects/${objectId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV2ObjectBookingObjectsObjectIdQueryKey = (objectId: string,) => {
    return [`/proxy/api/v2/object-booking/objects/${objectId}`] as const;
    }

    
export const getGetApiV2ObjectBookingObjectsObjectIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiV2ObjectBookingObjectsObjectId>>, TError = ErrorType<unknown>>(objectId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingObjectsObjectId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV2ObjectBookingObjectsObjectIdQueryKey(objectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV2ObjectBookingObjectsObjectId>>> = ({ signal }) => getApiV2ObjectBookingObjectsObjectId(objectId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(objectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingObjectsObjectId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV2ObjectBookingObjectsObjectIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV2ObjectBookingObjectsObjectId>>>
export type GetApiV2ObjectBookingObjectsObjectIdQueryError = ErrorType<unknown>



export function useGetApiV2ObjectBookingObjectsObjectId<TData = Awaited<ReturnType<typeof getApiV2ObjectBookingObjectsObjectId>>, TError = ErrorType<unknown>>(
 objectId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingObjectsObjectId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV2ObjectBookingObjectsObjectIdQueryOptions(objectId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV2ObjectBookingObjectsObjectIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV2ObjectBookingObjectsObjectId>>, TError = ErrorType<unknown>>(objectId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingObjectsObjectId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV2ObjectBookingObjectsObjectIdQueryKey(objectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV2ObjectBookingObjectsObjectId>>> = ({ signal }) => getApiV2ObjectBookingObjectsObjectId(objectId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingObjectsObjectId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV2ObjectBookingObjectsObjectIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV2ObjectBookingObjectsObjectId>>>
export type GetApiV2ObjectBookingObjectsObjectIdSuspenseQueryError = ErrorType<unknown>



export function useGetApiV2ObjectBookingObjectsObjectIdSuspense<TData = Awaited<ReturnType<typeof getApiV2ObjectBookingObjectsObjectId>>, TError = ErrorType<unknown>>(
 objectId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingObjectsObjectId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV2ObjectBookingObjectsObjectIdSuspenseQueryOptions(objectId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiV2ObjectBookingObjectsObjectIdBookings = (
    objectId: string,
    getBookingsByObjectIdRequest: BodyType<GetBookingsByObjectIdRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IBooking[]>(
      {url: `/proxy/api/v2/object-booking/objects/${objectId}/bookings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getBookingsByObjectIdRequest, signal
    },
      options);
    }
  


export const getPostApiV2ObjectBookingObjectsObjectIdBookingsMutationOptions = <TData = Awaited<ReturnType<typeof postApiV2ObjectBookingObjectsObjectIdBookings>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{objectId: string;data: BodyType<GetBookingsByObjectIdRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {
const mutationKey = ['postApiV2ObjectBookingObjectsObjectIdBookings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV2ObjectBookingObjectsObjectIdBookings>>, {objectId: string;data: BodyType<GetBookingsByObjectIdRequest>}> = (props) => {
          const {objectId,data} = props ?? {};

          return  postApiV2ObjectBookingObjectsObjectIdBookings(objectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError,{objectId: string;data: BodyType<GetBookingsByObjectIdRequest>}, TContext>}

    export type PostApiV2ObjectBookingObjectsObjectIdBookingsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV2ObjectBookingObjectsObjectIdBookings>>>
    export type PostApiV2ObjectBookingObjectsObjectIdBookingsMutationBody = BodyType<GetBookingsByObjectIdRequest>
    export type PostApiV2ObjectBookingObjectsObjectIdBookingsMutationError = ErrorType<unknown>

    export const usePostApiV2ObjectBookingObjectsObjectIdBookings = <TData = Awaited<ReturnType<typeof postApiV2ObjectBookingObjectsObjectIdBookings>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{objectId: string;data: BodyType<GetBookingsByObjectIdRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        TData,
        TError,
        {objectId: string;data: BodyType<GetBookingsByObjectIdRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiV2ObjectBookingObjectsObjectIdBookingsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const postApiV2ObjectBookingObjectsObjectIdAvailablePeriodsForMonth = (
    objectId: string,
    getAvailablePeriodsForMonthByObjectIdRequest: BodyType<GetAvailablePeriodsForMonthByObjectIdRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IAvailableBookingPeriod[]>(
      {url: `/proxy/api/v2/object-booking/objects/${objectId}/available-periods-for-month`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getAvailablePeriodsForMonthByObjectIdRequest, signal
    },
      options);
    }
  


export const getPostApiV2ObjectBookingObjectsObjectIdAvailablePeriodsForMonthMutationOptions = <TData = Awaited<ReturnType<typeof postApiV2ObjectBookingObjectsObjectIdAvailablePeriodsForMonth>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{objectId: string;data: BodyType<GetAvailablePeriodsForMonthByObjectIdRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {
const mutationKey = ['postApiV2ObjectBookingObjectsObjectIdAvailablePeriodsForMonth'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV2ObjectBookingObjectsObjectIdAvailablePeriodsForMonth>>, {objectId: string;data: BodyType<GetAvailablePeriodsForMonthByObjectIdRequest>}> = (props) => {
          const {objectId,data} = props ?? {};

          return  postApiV2ObjectBookingObjectsObjectIdAvailablePeriodsForMonth(objectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError,{objectId: string;data: BodyType<GetAvailablePeriodsForMonthByObjectIdRequest>}, TContext>}

    export type PostApiV2ObjectBookingObjectsObjectIdAvailablePeriodsForMonthMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV2ObjectBookingObjectsObjectIdAvailablePeriodsForMonth>>>
    export type PostApiV2ObjectBookingObjectsObjectIdAvailablePeriodsForMonthMutationBody = BodyType<GetAvailablePeriodsForMonthByObjectIdRequest>
    export type PostApiV2ObjectBookingObjectsObjectIdAvailablePeriodsForMonthMutationError = ErrorType<unknown>

    export const usePostApiV2ObjectBookingObjectsObjectIdAvailablePeriodsForMonth = <TData = Awaited<ReturnType<typeof postApiV2ObjectBookingObjectsObjectIdAvailablePeriodsForMonth>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{objectId: string;data: BodyType<GetAvailablePeriodsForMonthByObjectIdRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        TData,
        TError,
        {objectId: string;data: BodyType<GetAvailablePeriodsForMonthByObjectIdRequest>},
        TContext
      > => {

      const mutationOptions = getPostApiV2ObjectBookingObjectsObjectIdAvailablePeriodsForMonthMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const postApiV2ObjectBookingObjectsObjectIdCreateBooking = (
    objectId: string,
    availableBookingPeriod: BodyType<AvailableBookingPeriod>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IBooking>(
      {url: `/proxy/api/v2/object-booking/objects/${objectId}/create-booking`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: availableBookingPeriod, signal
    },
      options);
    }
  


export const getPostApiV2ObjectBookingObjectsObjectIdCreateBookingMutationOptions = <TData = Awaited<ReturnType<typeof postApiV2ObjectBookingObjectsObjectIdCreateBooking>>, TError = ErrorType<IError[]>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{objectId: string;data: BodyType<AvailableBookingPeriod>}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {
const mutationKey = ['postApiV2ObjectBookingObjectsObjectIdCreateBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV2ObjectBookingObjectsObjectIdCreateBooking>>, {objectId: string;data: BodyType<AvailableBookingPeriod>}> = (props) => {
          const {objectId,data} = props ?? {};

          return  postApiV2ObjectBookingObjectsObjectIdCreateBooking(objectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError,{objectId: string;data: BodyType<AvailableBookingPeriod>}, TContext>}

    export type PostApiV2ObjectBookingObjectsObjectIdCreateBookingMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV2ObjectBookingObjectsObjectIdCreateBooking>>>
    export type PostApiV2ObjectBookingObjectsObjectIdCreateBookingMutationBody = BodyType<AvailableBookingPeriod>
    export type PostApiV2ObjectBookingObjectsObjectIdCreateBookingMutationError = ErrorType<IError[]>

    export const usePostApiV2ObjectBookingObjectsObjectIdCreateBooking = <TData = Awaited<ReturnType<typeof postApiV2ObjectBookingObjectsObjectIdCreateBooking>>, TError = ErrorType<IError[]>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{objectId: string;data: BodyType<AvailableBookingPeriod>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        TData,
        TError,
        {objectId: string;data: BodyType<AvailableBookingPeriod>},
        TContext
      > => {

      const mutationOptions = getPostApiV2ObjectBookingObjectsObjectIdCreateBookingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const postApiV2ObjectBookingObjectsObjectIdValidateBookingPeriod = (
    objectId: string,
    availableBookingPeriod: BodyType<AvailableBookingPeriod>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IAvailableBookingPeriod>(
      {url: `/proxy/api/v2/object-booking/objects/${objectId}/validate-booking-period`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: availableBookingPeriod, signal
    },
      options);
    }
  


export const getPostApiV2ObjectBookingObjectsObjectIdValidateBookingPeriodMutationOptions = <TData = Awaited<ReturnType<typeof postApiV2ObjectBookingObjectsObjectIdValidateBookingPeriod>>, TError = ErrorType<IError[]>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{objectId: string;data: BodyType<AvailableBookingPeriod>}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {
const mutationKey = ['postApiV2ObjectBookingObjectsObjectIdValidateBookingPeriod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV2ObjectBookingObjectsObjectIdValidateBookingPeriod>>, {objectId: string;data: BodyType<AvailableBookingPeriod>}> = (props) => {
          const {objectId,data} = props ?? {};

          return  postApiV2ObjectBookingObjectsObjectIdValidateBookingPeriod(objectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError,{objectId: string;data: BodyType<AvailableBookingPeriod>}, TContext>}

    export type PostApiV2ObjectBookingObjectsObjectIdValidateBookingPeriodMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV2ObjectBookingObjectsObjectIdValidateBookingPeriod>>>
    export type PostApiV2ObjectBookingObjectsObjectIdValidateBookingPeriodMutationBody = BodyType<AvailableBookingPeriod>
    export type PostApiV2ObjectBookingObjectsObjectIdValidateBookingPeriodMutationError = ErrorType<IError[]>

    export const usePostApiV2ObjectBookingObjectsObjectIdValidateBookingPeriod = <TData = Awaited<ReturnType<typeof postApiV2ObjectBookingObjectsObjectIdValidateBookingPeriod>>, TError = ErrorType<IError[]>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{objectId: string;data: BodyType<AvailableBookingPeriod>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        TData,
        TError,
        {objectId: string;data: BodyType<AvailableBookingPeriod>},
        TContext
      > => {

      const mutationOptions = getPostApiV2ObjectBookingObjectsObjectIdValidateBookingPeriodMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getApiV2ObjectBookingMemberBookings = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IBooking[]>(
      {url: `/proxy/api/v2/object-booking/member/bookings`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV2ObjectBookingMemberBookingsQueryKey = () => {
    return [`/proxy/api/v2/object-booking/member/bookings`] as const;
    }

    
export const getGetApiV2ObjectBookingMemberBookingsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV2ObjectBookingMemberBookings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingMemberBookings>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV2ObjectBookingMemberBookingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV2ObjectBookingMemberBookings>>> = ({ signal }) => getApiV2ObjectBookingMemberBookings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingMemberBookings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV2ObjectBookingMemberBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV2ObjectBookingMemberBookings>>>
export type GetApiV2ObjectBookingMemberBookingsQueryError = ErrorType<unknown>



export function useGetApiV2ObjectBookingMemberBookings<TData = Awaited<ReturnType<typeof getApiV2ObjectBookingMemberBookings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingMemberBookings>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV2ObjectBookingMemberBookingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV2ObjectBookingMemberBookingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV2ObjectBookingMemberBookings>>, TError = ErrorType<unknown>>( options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingMemberBookings>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV2ObjectBookingMemberBookingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV2ObjectBookingMemberBookings>>> = ({ signal }) => getApiV2ObjectBookingMemberBookings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingMemberBookings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV2ObjectBookingMemberBookingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV2ObjectBookingMemberBookings>>>
export type GetApiV2ObjectBookingMemberBookingsSuspenseQueryError = ErrorType<unknown>



export function useGetApiV2ObjectBookingMemberBookingsSuspense<TData = Awaited<ReturnType<typeof getApiV2ObjectBookingMemberBookings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2ObjectBookingMemberBookings>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV2ObjectBookingMemberBookingsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const deleteApiV2ObjectBookingMemberBookingsBookingId = (
    bookingId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/proxy/api/v2/object-booking/member/bookings/${bookingId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteApiV2ObjectBookingMemberBookingsBookingIdMutationOptions = <TData = Awaited<ReturnType<typeof deleteApiV2ObjectBookingMemberBookingsBookingId>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{bookingId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {
const mutationKey = ['deleteApiV2ObjectBookingMemberBookingsBookingId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiV2ObjectBookingMemberBookingsBookingId>>, {bookingId: string}> = (props) => {
          const {bookingId} = props ?? {};

          return  deleteApiV2ObjectBookingMemberBookingsBookingId(bookingId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError,{bookingId: string}, TContext>}

    export type DeleteApiV2ObjectBookingMemberBookingsBookingIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV2ObjectBookingMemberBookingsBookingId>>>
    
    export type DeleteApiV2ObjectBookingMemberBookingsBookingIdMutationError = ErrorType<unknown>

    export const useDeleteApiV2ObjectBookingMemberBookingsBookingId = <TData = Awaited<ReturnType<typeof deleteApiV2ObjectBookingMemberBookingsBookingId>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{bookingId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        TData,
        TError,
        {bookingId: string},
        TContext
      > => {

      const mutationOptions = getDeleteApiV2ObjectBookingMemberBookingsBookingIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    